<script>
import { ArrowUpIcon, ChevronRightIcon } from "vue-feather-icons";

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";
import News from "@/components/news";

/**
 * Index-landing-two component
 */
export default {
  data() {
    return {};
  },
  components: {
    Navbar,
    Footer,
    News,
    ArrowUpIcon,
    ChevronRightIcon,
  },
};
</script>

<template>
  <div>
    <Navbar />
    <!-- Hero Start -->
    <section class="bg-half-170 d-table w-100">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
          <img src="images/magnificent-capital.svg" alt="" />
        </div>
          <div class="col-md-6">
            <div class="title-heading mt-4">
              <h1 class="display-4 opensans-tf font-weight-bold mb-3" style="font-weight: 500 !important;">
                Where Opportunities Become <span class="greatvibes-tf">Magnificent</span>
              </h1>
              <p class="opensans-tf para-desc text-black mb-0" style="font-weight: 300 !important;">
              Magnificent Capital Strives to serve our Institutional Clients with A World-class Experience for Alternative Investements.
              </p>
              <p class="para-desc text-black">
                New York | Orlando | Los Angeles
              </p>
            </div>
          </div>
          <!--end col-->

          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <div class="position-relative">
      <div class="shape overflow-hidden text-light">
        <svg
          viewBox="0 0 2880 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <!-- Hero End -->

    <section class="section bg-light">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h4 class="title mb-4">The Future of All Opportunity</h4>
              <p class="text-muted para-desc mb-0 mx-auto">
                Magnificent Capital is comprised from a Unique Team of up-to-date and experienced professionals. Results matter, which is why Magnificent Capital exclusively works with other like minded Institutions.
              </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <div class="row">
          <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
            <div
              class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center"
            >
              <div class="icons rounded h2 text-center text-primary px-3">
                <i class="bg-white uil uil-user-arrows"></i>
              </div>

              <div class="card-body p-0 content">
                <h5 class="mt-4">
                  <a href="javascript:void(0)" class="title text-dark"
                    >Relationship Management</a
                  >
                </h5>
                <p class="text-muted">
                  Working with Like-Minded Institutions who are passionate about the future, and understand an opportunity where one presents itself.
                </p>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
            <div
              class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center"
            >
              <div class="icons rounded h2 text-center text-primary px-3">
                <i class="bg-white uil uil-credit-card-search"></i>
              </div>

              <div class="card-body p-0 content">
                <h5 class="mt-4">
                  <a href="javascript:void(0)" class="title text-dark"
                    >Due Diligence</a
                  >
                </h5>
                <p class="text-muted">
                  Access to Decision Making Supplemental Materials are provided with an invitation to our Asset Management Solution Portal <br /><small> (For Qualified Entities Only)</small>
                </p>
              </div>
            </div>
          </div>
          <!--end col-->


          <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
            <div
              class="card features feature-clean explore-feature p-4 px-md-3 border-0 rounded-md shadow text-center"
            >
              <div class="icons rounded h2 text-center text-primary px-3">
                <i class="bg-white ri uil-university"></i>
              </div>

              <div class="card-body p-0 content">
                <h5 class="mt-4">
                  <a href="javascript:void(0)" class="title text-dark"
                    >Corporate Governance</a
                  >
                </h5>
                <p class="text-muted">
                  Our team is always up-to-date with the latest Securities and Exchange Commission (SEC) & FINRA  rules, Regulations, Laws, and reporting methods.
                </p>
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->

      <div class="container mt-100 mt-60">
        <div class="row align-items-center">
          <div class="col-lg-5 col-md-6">
            <img
              src="images/magnificent-quote.jpg"
              class="img-fluid rounded-md shadow-lg"
              alt=""
            />
          </div>
          <!--end col-->

          <div class="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
            <div class="section-title text-md-left text-center ml-lg-4">
              <h4 class="title mb-4">
              Participation is Exclusive
              </h4>
              <p class="text-muted mb-0 para-desc">
              Magnificent Capital is all about big-picture ideas that only our connected Professionals can deliver while building it's relationships. Participate in Private <em>Opportunities</em> and learn how we are shifting entire industries towards the road of Growth, Innovation, and Longevity.
              </p>

              <div class="media align-items-center text-left mt-4 pt-2">
                <div
                  class="text-primary h4 mb-0 mr-3 p-3 rounded-md shadow bg-white"
                >
                  <i class="uil uil-analysis"></i>
                </div>
                <div class="media-body">
                  Evergreen Projects with Global Recognition
                </div>
              </div>

              <div class="media align-items-center text-left mt-4">
                <div
                  class="text-primary h4 mb-0 mr-3 p-3 rounded-md shadow bg-white"
                >
                  <i class="uil uil-process"></i>
                </div>
                <div class="media-body">
                  Truly Unique Diversification
                </div>
              </div>

              <div class="media align-items-center text-left mt-4">
                <div
                  class="text-primary h4 mb-0 mr-3 p-3 rounded-md shadow bg-white"
                >
                  <i class="uil uil-puzzle-piece"></i>
                </div>
                <div class="media-body">
                 Mute Exposure to the Markets
                </div>
              </div>
              <div class="mt-4">
            <small class="text-muted" ><em>Opportunities</em> are by Invitation only, and Suitability Standards must be met.</small></div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->


    <!--end section-->
    <!--end section-->
    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>
